
    import __i18nConfig from '@next-translate-root/i18n.json'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import type { GetStaticProps } from 'next';
import MusicLanding, { type MusicLandingProps, } from '@/components/music-landing/MusicLanding';
import { getMusicPageProps } from '@/components/music-landing/server';
export default function AiMusicGeneratorPage(props: MusicLandingProps) {
    return <MusicLanding {...props}/>;
}
const getStaticProps: GetStaticProps<MusicLandingProps> = async ({ locale, }) => {
    const props = getMusicPageProps('main', locale);
    if (!props)
        return { notFound: true };
    return { props };
};

    async function __Next_Translate__getStaticProps__1a12e86ecb5__(ctx) {
      if (typeof global !== 'undefined') {
        global.i18nConfig = __i18nConfig
      }
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/ai-music-generator/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import('../../../locales/' + l + '/' + n).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a12e86ecb5__ as getStaticProps }
  